module.exports = __webpack_public_path__ + "static/MSD-3fb49d437605a009600a8295f8a95ba2.png";